<template>
  <div id="app">
    <layout>
      <router-view/>
    </layout>
    
  </div>
</template>

<script>
import Vue from 'vue';
import Layout from '@/Layout.vue';
import Widget from '@/Widget.vue';

Vue.component('widget', Widget);

export default {
  components: {
    Layout
  },

  created() {
    this.$store.dispatch('init'); // initialize the store
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue